import Vue from "vue";
import App from "./App.vue";
import "./style/cssStyle.css";
import router from "./router";
import Vant from "vant";
import "vant/lib/index.css";
import "@vant/touch-emulator";

Vue.use(Vant);

Vue.prototype.$publicURL = "./";
Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
